import React from "react";
import { Box, ButtonGroup, Card, InlineStack, Text } from "@shopify/polaris";
import HorseButton from "../../common/HorseButton";

function EmptyRecommendationCard({
  title,
  header,
  infoMessage,
  imageSrc,
  seeMoreUrl,
  seeMoreUrlText = "Explore trend",
}: {
  readonly title: string;
  readonly header: string;
  readonly infoMessage: string;
  readonly imageSrc: string;
  readonly seeMoreUrl?: string;
  readonly seeMoreUrlText?: string;
}): React.JSX.Element {
  return (
    <Card>
      <Text as="h2" variant="headingSm">
        {title}
      </Text>
      <Box padding="400">
        <InlineStack align="center">
          <img height={187} src={imageSrc} />
        </InlineStack>
      </Box>
      <Box padding="400">
        <Text alignment="center" as="p" fontWeight="bold" variant="bodyMd">{header}</Text>
        <Text alignment="center" as="p" variant="bodyMd">{infoMessage}</Text>
      </Box>

      {seeMoreUrl ? <Box padding="400">
        <InlineStack align="end">
          <ButtonGroup>
            <HorseButton url={seeMoreUrl} variant="plain">
              {seeMoreUrlText}
            </HorseButton>
          </ButtonGroup>
        </InlineStack>
      </Box> : null}
    </Card>
  );
}

export default EmptyRecommendationCard;
